import { render, staticRenderFns } from "./PayrollAddEditModal.vue?vue&type=template&id=577b6425"
import script from "./PayrollAddEditModal.vue?vue&type=script&lang=js"
export * from "./PayrollAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports